// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'hanger';

export const Component = () => (
  <path d='m24.11 19.587-10.63-8.956-.048-.144c0-.048.048-.096.096-.144.814-.335 1.485-.958 1.916-1.772.431-.814.527-1.676.335-2.586-.144-.718-.431-1.389-.958-1.915a3.584 3.584 0 0 0-1.868-1.006c-1.101-.191-2.06.048-2.873.67-.958.767-1.437 1.773-1.437 3.066 0 .335.144.478.48.478.334 0 .526-.143.526-.478 0-.958.382-1.725 1.101-2.3.623-.431 1.246-.622 1.963-.479a2.46 2.46 0 0 1 1.341.72c.383.43.623.91.719 1.436.144.719.048 1.34-.24 1.963-.334.623-.766 1.054-1.388 1.293-.383.144-.623.431-.719.862-.048.431.048.766.335 1.054l10.68 9.004.048.191a.102.102 0 0 1-.096.096H1.122c-.048 0-.048-.048-.048-.096-.047-.096 0-.144.048-.191l8.429-6.801c.287-.192.287-.431.047-.67-.239-.24-.478-.24-.718-.048L.45 19.587c-.43.335-.574.766-.334 1.293.143.527.479.766 1.005.766h22.27c.527 0 .91-.239 1.054-.718.192-.527.096-.958-.335-1.341Z' />
);

export const viewBox = '0 0 25 25';
